import React,{ useState,useEffect  } from 'react';
import { connect } from 'react-redux';
import {  useLocation,useNavigate,Link } from 'react-router-dom';

import Logo  from '../../assets/ipo/logo.png'
import Logo1  from '../../assets/icon/lp.png'
import bnbLogo  from '../../assets/icon/bnblogo.png'
import polygonLogo  from '../../assets/icon/polygon.png'
import './head.less';
import { message, Drawer,Space,Collapse   } from 'antd'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next';
import {init} from '../../utils/ethers'
import { CSSTransition } from 'react-transition-group';
import { 
    MenuOutlined,
    CheckOutlined,
    CaretRightOutlined,
    CloseOutlined,
    WarningOutlined,
    DownOutlined,
    UpOutlined,
    WalletOutlined
    } from '@ant-design/icons'
import {login,register} from "../../api";

const { Panel } = Collapse;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        lan:state.lan,
        pAddress:state.pAddress,
        flash:state.flash
        
        
    }
}

const Head = (props) => {
    const { t } = useTranslation()
    const [isShowMenu,setIsShowMenu] = useState(false);
  const [showJoinBind,setShowJoinBind] = useState(false)
     const [puser,setPuser] = useState("")

    const [showTag,setShowTag]=useState(1)
const [isShowMenu1,setIsSHowMenu1] = useState(false)
    // const handleCancel = () =>{setIsShowMenu(false)}
  
    const showMenu = () =>{setIsShowMenu(!isShowMenu)}
    
    const location = useLocation()
    const { search} = location
    const navigate = useNavigate()//hook事件路由跳转
const [scrolled, setScrolled] = useState(false);
    
   
    let i=1;
    let iarr=[]
    iarr = search.split('?i=')
    if(iarr.length>1){
        i = iarr[1].slice(0,10)
    }
 

   
    
    if (i.length == 10){
        props.setPAddress(i)
         sessionStorage.setItem('i',i);  
    }
    // let sessioni=sessionStorage.getItem('i') || ""
    // if(i!==1){
    //     sessionStorage.setItem('i',i);  
    // }else{
    //     if(sessioni){
    //         i=sessioni;
    //     }else{
    //         sessionStorage.setItem('i',i); 
    //     }
    // }


    
    


     const changeLan = (e) =>{
        props.setLan(e)
        i18n.changeLanguage(e)
        setIsSHowMenu1(false)
        localStorage.setItem("lan",e)
      }

    const par1 = ()=>{
            navigator.clipboard.readText().then((text) => {
                if(text.length!=10){
                    message.error(t('head.地址格式不正确'))
                    return
                }
                props.setPAddress(text)
            }, () => {
                console.log('Paste failed');
            });
        }

    
    const _register = () =>{
  
        
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            let sessioni=sessionStorage.getItem('i') || ""
            if (sessioni.length == 10){
                
            }else{
                message.error(t('head.推荐人地址不能为空'))
                    return false
            }
            // if(props.pAddress.length==0 ){
            //     message.error(t('head.推荐人地址不能为空'))
            //     return false
            // }
            register({address:props.address,pAddress:sessioni}).then(res=>{
                if(res.code == 0){
                    message.success(t('head.绑定成功'))
                    setPuser(res.data.puser)
                    setShowJoinBind(false)
                    props.setIsLogin(true)
    
                }else{
                    message.error(res.msg)
                }
    
            })
        }
    

    const connectWallet = () =>{ 
        let sessioni=sessionStorage.getItem('i') || ""
        if (sessioni.length == 10){
            props.setPAddress(sessioni)
        }
        console.log(sessioni)
    //       const timestamp = parseInt(new Date().getTime() /1000);
    // console.log(timestamp)
                 
    // if(timestamp<1755603000){
    //     message.error(t('g.暂未开始'))
    //             return false
    // }
            init().then(
                res=>{
                    login({address:res.address,pass:res.pass}).then(res1=>{
                        if (res1.code == 0){
                            message.success(t('head.连接成功'))
                            props.setIsLogin(res1.data.has)
                            if(!res1.data.has){
                                // go4()
                                message.warn(t('head.您还未绑定钱包，请绑定激活钱包地址'))
                                props.setFlash(!props.flash)
                                return
                            }
                        }else{
                            props.setAddress("")
                            message.error(res1.msg)
                        }
                },err=>{
                    props.setAddress("")
                    message.error(t('head.连接失败')+"请检测您的网络环境")
                } )

            })
        
        
    }
 
    const go4 = ()=>{
        setIsShowMenu(false)

        navigate("/mint",{
            state:{
                address:props.address
            }
        })
    }

    const wei = ()=>{
        message.warn(t('mint.即将开放'))

        
    }
  
    const goLiushui = (url)=>{
        //     message.error(t('g.暂未开放'))
        //    return
           
            navigate(url)
        }
    
    
    useEffect(() => {
        // setTimeout(() => {
        //     connectWallet()
        // }, 2000);
         if(props.address.length>0 && !props.isLogin){
                props.setFlash(true)
            }

        
    }, 
    // eslint-disable-next-line
    []);
    
    return (
        <>
       
        <div   className='mm lg:w-1/3 md:w-1/3 sm:1/2 headBg left-0 right-0 mx-[4px]   flex flex-row justify-between items-center h-12  text-white  fixed top-0 headzindex999' >
            <div className=' w-2/5 flex flex-row justify-start items-center'>
                {/* <div onClick={showMenu} className='w-2 ml-5 text-white flex flex-row justify-center items-center text-[10px]'>
                {
                    isShowMenu?(
                        <CloseOutlined  onClick={showMenu}/>
                    ):(
                        <MenuOutlined onClick={showMenu} />
                    )
                }
                
                </div> */}
                <img className='  ml-4' alt='logo' src={require('../../assets/ipo/logo1.png')} style={{"width":"20px"}}></img>
                 <img className='  ml-[4px]' alt='logo' src={require('../../assets/ipo/logo.png')} style={{"width":"75px"}}></img>
            </div>
            <div className=' w-3/5 pr-5 flex flex-row justify-end items-center'>
                <div>
                    <div onClick={showMenu} className="
                            relative inline-flex h-4 items-center justify-center
                            px-2 py-1 text-white text-[10px]  tracking-wider
                            [--cut:3px] [--border:1px]
                            before:absolute before:inset-0 before:bg-[#1A181A]
                            before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            after:absolute after:inset-[var(--border)] after:bg-[#01060A]
                            after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                        ">

                            {
                            props.lan==='en'?(
                                <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/0.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">EN</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='zh'?(
                                  <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/1.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">ZH</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='es'?(
                                  <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/2.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">ES</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='fr'?(
                                  <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/3.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">FR</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='ko'?(
                                <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/4.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">KO</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='ja'?(
                                <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/5.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">JA</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='ar'?(
                                <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/6.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">AR</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):props.lan==='ru'?(
                                <>
                                <img className='  z-10' alt='' src={require('../../assets/qi/7.jpg')} style={{"width":"15px","height":"10px"}}></img>
                                <span className="ml-1 z-10 text-[8px] text-[#F9B514]">RU</span>
                                <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  onClick={showMenu} /></span>
                                </>
                            ):null
                        }
                    
                     
                    </div>
                </div>
                <div className='ml-2 flex flex-row items-center'>
                    <div className="
                            relative inline-flex h-5 items-center justify-center
                            px-2 py-2 text-white text-[10px]  tracking-wider
                            [--cut:4px] [--border:1px]
                            before:absolute before:inset-0 before:bg-[#C89C01]
                            before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            after:absolute after:inset-[var(--border)] after:bg-[#01060A]
                            after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                        ">
                            {
                                !props.isLogin?(
                                <span onClick={connectWallet} className="block w-24 ml-1 z-10 text-[10px] text-[#C89C01] text-center">{t('head.连接钱包')}</span>
                            ):(
                                <span className="block w-24 ml-1 z-10 text-[11px] text-[#C89C01]" style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</span>
                                
                            )
                            }
                         
                        
                        
                    </div>
                </div>
            </div>
            
            
            

    
            
        
            {/* <div className=' w-6/12 flex flex-row justify-end items-center'>
            {
                    !props.isLogin?(
                        <button onClick={connectWallet} className='px-4 h-10 bg-gradient-to-b from-[#0161F6] to-[#1B43FD]   text-white rounded-md  text-xs text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('head.连接钱包')}</span></button>
                    ):(
                        <button className=' w-4/5 h-10   bg-gradient-to-b from-[#0161F6] to-[#1B43FD] text-white rounded-md  font-extrabold text-xs text-center px-2 flex flex-row items-center' ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-network w-4 h-4" aria-hidden="true"><rect x="16" y="16" width="6" height="6" rx="1"></rect><rect x="2" y="16" width="6" height="6" rx="1"></rect><rect x="9" y="2" width="6" height="6" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path><path d="M12 12V8"></path></svg><div className=' w-4/5 mr-1 ml-1' style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</div><div className='w-2 h-2 rounded-full bg-green-500'></div></button>
                    )
                }
                
            </div> */}

            
            
            
           
            
        </div>
      

        <CSSTransition
                    in={props.flash&&!props.isLogin}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('')}
                    onEntering={(e) => console.log('')}
                    onEntered={(e) => console.log('')}
                    onExit={(e) => console.log('')}
                    onExiting={(e) => console.log('')}
                    onExited={(e) => console.log('')}>
                    <div   className=' w-full lg:w-1/4 h-screen fixed left-0 top-0   text-white  shadow-md    z-[1000] bg-black/95'>
                        <div className='fcodeBg  mx-auto mt-24 w-[325px] h-[232px]    '>
                                   
                            <div className=' w-full  px-2 pt-[135px] flex flex-row justify-center items-center'>
                                <div className=" w-56
                                    relative inline-flex h-[30px] items-center justify-center
                                    px-2 py-2 text-white text-[10px]  tracking-wider
                                    [--cut:4px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-[#B26304]
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#0B0D0E]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    ">
                                        <span className=' text-sm z-10 text-gray-100 lessAddress'>{props.isLogin?puser:props.pAddress}</span>
                                    </div> 
                                
                            </div>
                       
                            <div onClick={_register} className=' w-40 h-12 mt-2 mb-4 rounded-md mx-auto flex flex-row justify-center items-center '>
                                <button className="sci-glow-btn "> <span className='  text-gray-200 text-xs '>{t('head.确定绑定!')}</span></button>
                            
                            </div>
                                  
                                    
                        </div>
                    </div>
                    </CSSTransition>
      
        <CSSTransition
            in={isShowMenu}
            unmountOnExit={true}
            classNames='lan'
            timeout={1000}
            appear
            onEnter={(e) => console.log('开始进入动画')}
            onEntering={(e) => console.log('执行进入动画')}
            onEntered={(e) => console.log('进入动画结束')}
            onExit={(e) => console.log('开始离开动画')}
            onExiting={(e) => console.log('正在离开动画')}
            onExited={(e) => console.log('离开动画结束')}>
            <div   className=' w-full lg:w-1/4 h-screen fixed left-0 top-0   text-white  shadow-md    z-[1000] bg-black/90'>
               <div className='lanBg  mx-10 mt-24 w-[300px] h-[290px]  pt-24 pl-8 pr-7  relative'>
                    <div onClick={()=>setIsShowMenu(false)} className='w-8 h-8 absolute right-0 top-0'></div>
                    <div className='w-full mb-2 flex flex-row justify-between items-center'>
                        <div onClick={()=>{changeLan("en");setIsShowMenu(false)}} className={`${props.lan==='en'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/0.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>English</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>EN</span>
                        </div>
                        <div onClick={()=>{changeLan("zh");setIsShowMenu(false)}}  className={`${props.lan==='zh'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/1.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>繁體中文</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>ZH</span>
                        </div>
                    </div>
                    <div   className='w-full mb-2 flex flex-row justify-between items-center'>
                        <div onClick={()=>{changeLan("es");setIsShowMenu(false)}} className={`${props.lan==='es'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/2.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>Español</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>ES</span>
                        </div>
                        <div onClick={()=>{changeLan("fr");setIsShowMenu(false)}}  className={`${props.lan==='fr'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/3.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>Français</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>FR</span>
                        </div>
                    </div>
                    <div  className='w-full mb-2 flex flex-row justify-between items-center'>
                        <div onClick={()=>{changeLan("ko");setIsShowMenu(false)}}  className={`${props.lan==='ko'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/4.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>한국어</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>KO</span>
                        </div>
                        <div onClick={()=>{changeLan("ja");setIsShowMenu(false)}}  className={`${props.lan==='ja'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/5.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>日本語</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>JA</span>
                        </div>
                    </div>
                    <div className='w-full mb-2 flex flex-row justify-between items-center'>
                        <div onClick={()=>{changeLan("ar");setIsShowMenu(false)}}  className={`${props.lan==='ar'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/6.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>العربية</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>AR</span>
                        </div>
                        <div onClick={()=>{changeLan("ru");setIsShowMenu(false)}}  className={`${props.lan==='ru'?'lanBg2':'lanBg1'} w-28 h-7 px-3 flex flex-row justify-between items-center`}>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='  mr-2' alt='' src={require('../../assets/qi/7.jpg')} style={{"width":"15px"}}></img>
                                <span className=' text-[9px] text-gray-300'>Русский</span>
                            </div>
                            <span className=' text-[9px] text-gray-600'>RU</span>
                        </div>
                    </div>
               </div>
                  
                
            </div>
            </CSSTransition>
        

       
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{
        setLan(value){
            const action ={type:"setLan",value:value}
            dispatch(action)
        },
        setAddress(value){
            const action ={type:"setAddress",value:value}
            dispatch(action)
        },
        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },
        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Head);
